import { render, staticRenderFns } from "./zbscroll.vue?vue&type=template&id=16a6a2d6&"
import script from "./zbscroll.vue?vue&type=script&lang=js&"
export * from "./zbscroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports